// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\SocketTokenResponse

export type SocketTokenApiResponse = {
	token: string;
};

export type SocketToken = {
	token: string;
};

export function hydrateSocketToken(data: SocketTokenApiResponse): SocketToken {
	return { ...data };
}